import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import{ SeoService, AppContext } from '../../shared';

@Component({
  selector: 'online-search',
  styles: [require('./online-search.component.scss'), require('.//../static.scss')],
  template: require('./online-search.component.html')
})
export class OnlineSearchComponent implements AfterViewInit {

  constructor(private route: ActivatedRoute, private seo: SeoService, private app: AppContext) {
    // Do stuff
  }

  title = 'Online Search - Linescape';
  description = 'Linescape is the first liner shipping search engine dedicated to ocean container schedules and routes with searches filtered by port, vessel or carrier.';


  ngAfterViewInit() {
    this.seo.set(this.title, this.description);
    this.route.params.subscribe(params => {
      if (params['scroll'] != null && params['scroll'] === 'true') {
        window.scrollTo(0, 0);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/static/online-search/online-search.component.ts